import { Component, OnInit, ViewChild, AfterContentInit, AfterViewInit, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabsetComponent, TabDirective } from 'ngx-bootstrap/tabs';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/_services/api.service';
import { Subject, Subscription } from 'rxjs';
import { share } from 'rxjs/operators';
import { LanguageService } from 'src/app/_services/language.service';

@Component({
    selector: 'app-realproperty',
    templateUrl: './realproperty.component.html',
    styleUrls: ['./realproperty.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RealpropertyComponent implements OnInit, AfterViewInit {
  
  id: number;

  constructor(private actRoute: ActivatedRoute) {
    // this.id = this.actRoute.snapshot.params.id;
  }
  ngAfterViewInit() {

  }

  ngOnInit() {
  }


}
